import Utility from "../utility/utility";
import ModuleManager from "../framework/core/module_manager";
import HallServer from "../pacakge/hall/server/hall/hall_serve";
import SdkFacebook from "../sdk/collection/sdk_facebook";

import {Base64} from "../utility/base64";
import SdkLine from "../sdk/collection/sdk_line";
import Debug from "./debug";
import SdkDefine from "../sdk/collection/sdk_define";
import SdkStorage from "../sdk/SdkStorage";
import LogManager from "./log_manager";

export default class SdkManager extends cc.Component {
    
    private static _instance : SdkManager;
    
    public static get instance() : SdkManager {

        if (!SdkManager._instance) {
            
            SdkManager._instance = new SdkManager();
        }
        return SdkManager._instance;
    }

    private sdkLoginCallback
    public setSdkLoginCallback(callback) {
        SdkManager.instance.sdkLoginCallback = callback
    }

    public receive(content : string, encode = true){

        // cc.log(" receive " + content , " encode " + encode);
    
        let json = JSON.parse(encode ? Utility.decodeBase64(content) : content );        
        if (json.sdkName == SdkDefine.FACE_BOOK_NAME) {            
            SdkFacebook.instance.receive(json, SdkManager.instance.sdkLoginCallback);
            this.sdkLoginCallback = null
        }else if(json.sdkName == SdkDefine.LINE_NAME){
            SdkLine.instance.receive(json, SdkManager.instance.sdkLoginCallback);
            this.sdkLoginCallback = null
        }
        LogManager.instance.log(`SdkManager receive content: ${content} encode: ${encode}`, true)
        
    }

    public requestNativeFunc(skdName : string, funcName : string,jsonParam : string = "",showNetPrompt = true ){
  
        if (showNetPrompt) {
            ModuleManager.instance.showModuleName("NetPrompt", { showImmediately: true })
        }
        
        let jsonObj = { "sdkName" : skdName, 
                        "funcName": funcName, 
                        "params": jsonParam };                                

        let jsonStr = JSON.stringify(jsonObj);

        if (cc.sys.os == cc.sys.OS_ANDROID) {

            let className = "project/sdk/SDKManager";            
            jsb.reflection.callStaticMethod(className, "receiveJSCall","(Ljava/lang/String;)V",jsonStr);
        }      
        else if(cc.sys.os == cc.sys.OS_IOS){

            let className = "SDKManager";
            let result = jsb.reflection.callStaticMethod(className,"receiveJSCall:",jsonStr);
        }
        LogManager.instance.log(`SdkManager request sdkName : ${skdName}, funcName : ${funcName} encode: ${jsonParam}`, true)
    }    

    /**
     * 请求分享
     */
    public req_share( sdkName , json ){
        
        if (cc.sys.isNative) {
        
            this.requestNativeFunc(sdkName,"req_share",JSON.stringify(json),false);

        }else if(cc.sys.isBrowser){

            if (sdkName == SdkDefine.FACE_BOOK_NAME) {
            
                cc.game.emit('fb_share',json);
                
            }else if(sdkName == SdkDefine.LINE_NAME){

                cc.game.emit('line_share',json);
            }
            
        }
        
    }   
 

}
//@ts-ignore
window.sdkMgr = SdkManager.instance;


